import { F } from '../context'
import { GetVariable, GetVariableValue, Update } from '../hooks'
import {
  BrandingFontStyle,
  BrandingThemeType,
  ComponentType,
  Screen,
  ScreenComponent,
  carouselHandler,
  createElement,
  getComponentTypeById,
  listHandler,
  listItemName,
  listItemNameCopy,
  listSectionHeaderName,
  listSectionHeaderNameCopy,
  overlayHandler,
  progressIndicatorHandler,
  showMoreButtonHandler,
} from './index'

export const setComponents = async (
  f: F,
  components: ScreenComponent[],
  parent: HTMLElement,
  fontFamily: string,
  fontStyles: BrandingFontStyle[],
  language: string,
  theme: BrandingThemeType,
  setTheme: React.Dispatch<React.SetStateAction<BrandingThemeType>>,
  desktopMode: boolean,
  desktopRootScroll: boolean,
  desktopRootList: boolean,
  firstChildOfScreen: boolean,
  navigate: (pathname: string) => void,
  navigateBack: () => void,
  openDialog: (page: string, beforeClose?: () => Promise<void>) => void,
  closeDialog: () => Promise<void>,
  closeAllDialogs: () => void,
  screens: Screen[],
  screenConfig: Screen,
  getVariableValue: GetVariableValue,
  getVariable: GetVariable,
  update: Update,
  setScroll: (func: () => void) => void,
  limit: number,
  setLimit: (limit: number) => void
) => {
  const setSubComponents = async (element: HTMLElement, component: ScreenComponent) => {
    const {
      id,
      name,
      componentType,
      subComponents = [],
      listId,
      indexInList,
      numberOfLines,
      showMoreTextButton,
      value,
      duration,
      loop,
    } = component
    const isListItem = name === listItemName || name === listItemNameCopy
    const isListSectionHeader = name === listSectionHeaderName || name === listSectionHeaderNameCopy
    const isOverlay = componentType === ComponentType.overlay
    const isText = componentType === ComponentType.text
    const isCarousel = componentType === ComponentType.carousel
    const isProgressIndicator = componentType === ComponentType.progressIndicator
    const isList = componentType === ComponentType.list
    await setComponents(
      f,
      subComponents,
      element,
      fontFamily,
      fontStyles,
      language,
      theme,
      setTheme,
      desktopMode,
      false,
      false,
      false,
      navigate,
      navigateBack,
      openDialog,
      closeDialog,
      closeAllDialogs,
      screens,
      screenConfig,
      isListItem || isListSectionHeader ? getVariable(screenConfig, listId, indexInList) : getVariableValue,
      getVariable,
      update,
      setScroll,
      limit,
      setLimit
    )
    if (isOverlay) {
      overlayHandler(element)
    } else if (isText) {
      await showMoreButtonHandler(element, getVariableValue, numberOfLines, showMoreTextButton)
    } else if (isCarousel) {
      await carouselHandler(id, element, getVariableValue, value, duration, loop, listId, indexInList)
    } else if (isProgressIndicator) {
      await progressIndicatorHandler(id, element, getVariableValue, value, duration, loop, listId, indexInList)
    } else if (isList) {
      listHandler(element)
    }
  }
  for (const component of components) {
    const { name, listId, indexInList } = component
    const isListItem = name === listItemName || name === listItemNameCopy
    const isListSectionHeader = name === listSectionHeaderName || name === listSectionHeaderNameCopy
    const onlyChild =
      firstChildOfScreen || getComponentTypeById(parent.id) === ComponentType.carousel || components.length === 1
    await createElement(
      f,
      setSubComponents,
      component,
      parent,
      fontFamily,
      fontStyles,
      language,
      theme,
      setTheme,
      desktopMode,
      desktopRootScroll,
      desktopRootList,
      firstChildOfScreen,
      onlyChild,
      navigate,
      navigateBack,
      openDialog,
      closeDialog,
      closeAllDialogs,
      screens,
      screenConfig,
      isListItem || isListSectionHeader ? getVariable(screenConfig, listId, indexInList) : getVariableValue,
      getVariable,
      update,
      setScroll,
      limit,
      setLimit
    )
  }
}
